import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Tomar decisiones desde tu intuición (y no desde miedo)', 'Identificar y transformar creencias que bloquean merecimiento y abundancia', 'Cuidar tu energía en relaciones y sostener límites sin tanta culpa', 'Tener una rutina simple de manifestación para sostener foco y acción', 'Sanar patrones de niña interior (vergüenza, rechazo, "no puedo sostenerlo")', 'Mejorar tu vínculo con el dinero: menos evitación, más orden y calma', 'Soltar el control sin abandonar tu objetivo', 'Integrar tu sombra para que deje de sabotearte'];
  return <section className="w-full bg-gradient-to-b from-cream-200 to-cream-100 py-20 md:py-28 px-4" data-id="element-30">
      <div className="max-w-5xl mx-auto" data-id="element-31">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-3xl md:text-4xl text-brown-700 text-center mb-12" data-id="element-32">
          Qué vas a lograr con esta guía
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-33">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex items-start gap-4 bg-white/70 backdrop-blur-sm p-5 rounded-xl border border-gold-100 shadow-sm" data-id="element-34">
              <div className="w-8 h-8 bg-gradient-to-br from-gold-400 to-gold-500 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-35">
                <StarIcon className="w-4 h-4 text-white" data-id="element-36" />
              </div>
              <span className="text-brown-600" data-id="element-37">{benefit}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}